import React, {Component} from 'react';

import hoursIcon from "../../../img/ic-hours-large.svg";

import "../../../css/LocationDetail.css";

const daysOfTheWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
]

class LocationHoursTable extends Component{
    closeKey(day){
        return day.toLowerCase() + "Close";
    }
    openKey(day){
        return day.toLowerCase() + "Open";
    }

    buildDayRow(day){
        if(!this.props.location.businessHours[this.openKey(day)]){
            return (<div className="hoursValue closed">Closed</div>)
        }
        else{

            var open = this.formatTime(this.props.location.businessHours[this.openKey(day)] );
            var close = this.formatTime(this.props.location.businessHours[this.closeKey(day)] );
                return (<div className="hoursValue">{open + " - " + close}</div>);
            }

    }

    formatTime(t){
        var hour, minute;
        var amPM = "AM";
        [hour, minute] = t.split(":");
        hour = parseInt(hour, 10);
        if (hour >= 12){
            hour -= 12;
            amPM = "PM"
        }
        hour = hour || 12;
        if(minute.length === 1){
            minute = "0" + minute;
        }
        return hour + ":" + minute + " " + amPM;

    }

    render(){
        return (
               <div className="detailHours container minPadded" style={{flex:1 }}>
                    <div className="innerCenterDiv flex1">
                        <div className="container flex1">
                            <div className="hoursAvailableIconPanel container">
                                   <img className="hoursIcon" src={hoursIcon} alt="hours available icon" />
                            </div>

                            <div className="container vertical detailHoursWrapper flex1">
                               <div className="hoursHeader hoursRow " >
                                   Hours
                               </div>
                               {this.props.location.businessHours && Object.keys(this.props.location.businessHours).length ?
                                   daysOfTheWeek.map((day, index) =>{
                                       return (
                                           <div className="hoursRow container horizontal" key={"hour-row-" + index}>
                                               <div className="day" style={{flex: 1}}>{day}</div>
                                               {this.buildDayRow(day)}
                                           </div>
                                       )
                                   })
                                   :
                                   <div style={{fontFamily: "Lato", fontSize: "16px", color: "#1c5c7f"}}>This information is not available yet</div>
                               }
                            </div>

                        </div>

                   </div>

               </div>

        )
    }

}

export default LocationHoursTable;



// WEBPACK FOOTER //
// ./src/components/locator/details/LocationHoursTable.js